import { InputNumber } from "antd";
import { useSettings } from "../../../hooks";

export default function SetTableWidth() {
  const { settings, setSettings } = useSettings();

  return (
    <InputNumber
      className="w-full"
      style={{ width: "100%" }}
      value={settings.tableWidth}
      onChange={(value) => {
        if (value < 180) return;
        setSettings((prev) => ({ ...prev, tableWidth: value }));
      }}
    />
  );
}
